import api from '@shop/frontend/web/js/api';
import { reactive, readonly, ref } from 'vue';

/**
 * Тип состояния мероприятия
 * @typedef {Object} EventsState
 * @property {Array} items
 * @property {boolean} showLoadMore
 * @property {boolean} loading
 * @property {boolean} loadingMore
 * @property {number} page
 */

export const blockingTypeEnum = {
  MATCH: 'match',
  SUBSCRIPTION: 'subscription',
  SERVICE_TAGLESS: 'service_tagless',
  PERFORMANCE: 'performance',
  SHOW: 'show',
};

const DEFAULT_STATE = {
  items: [],
  showLoadMore: false,
  loading: false,
  loadingMore: false,
  page: 0,
};

const eventsState = reactive({ ...DEFAULT_STATE });
const subscriptionsState = reactive({ ...DEFAULT_STATE });
const servicesState = reactive({ ...DEFAULT_STATE });
const performancesState = reactive({ ...DEFAULT_STATE });
const showState = reactive({ ...DEFAULT_STATE });

const selectTypes = reactive({
  items: [
    blockingTypeEnum.MATCH,
    blockingTypeEnum.SUBSCRIPTION,
    blockingTypeEnum.PERFORMANCE,
    blockingTypeEnum.SHOW,
  ],
});

const paramsState = ref({
  dateRange: [],
  selectTypes: [],
});

/**
 * @param {Object} [params]
 * @param {Object<string, any>} params.searchParams
 */
async function searchItems(state, type, params = {}) {
  try {
    state.page = 0;
    paramsState.value = params;
    state.loading = true;
    state.items = [];

    const res = await api.poster.getPosterItems({
      blocking: blockingTypeEnum[type],
      params,
    });

    state.items = res.items;
    state.showLoadMore = res.leftCount > 0;
  } catch (e) {
    console.log(e);
  } finally {
    state.loading = false;
  }
}

async function loadMoreItems(state, type) {
  try {
    state.page += 1;
    state.loadingMore = true;

    const res = await api.poster.getPosterItems({
      blocking: blockingTypeEnum[type],
      pagination: {
        page: state.page,
      },
      params: paramsState.value,
    });

    state.items = state.items.concat(res.items);
    state.showLoadMore = res.leftCount > 0;
  } catch (e) {
    console.log(e);
  } finally {
    state.loadingMore = false;
  }
}

function searchEvents(params = {}) {
  searchItems(eventsState, 'MATCH', params);
}

function loadMoreEvents() {
  loadMoreItems(eventsState, 'MATCH');
}

function searchSubscriptions(params = {}) {
  searchItems(subscriptionsState, 'SUBSCRIPTION', params);
}

function loadMoreSubscriptions() {
  loadMoreItems(subscriptionsState, 'SUBSCRIPTION');
}

function searchServices(params = {}) {
  searchItems(servicesState, 'SERVICE_TAGLESS', params);
}

function loadMoreServices() {
  loadMoreItems(servicesState, 'SERVICE_TAGLESS');
}

function searchPerformances(params = {}) {
  searchItems(performancesState, 'PERFORMANCE', params);
}

function loadMorePerformances() {
  loadMoreItems(performancesState, 'PERFORMANCE');
}

function searchShows(params = {}) {
  searchItems(showState, 'SHOW', params);
}

function loadMoreShows() {
  loadMoreItems(showState, 'SHOW');
}

function setSelectTypes(items) {
  selectTypes.items = items;
}

export default function useSiteStore() {
  return {
    getEventsState: readonly(eventsState),
    searchEvents,
    loadMoreEvents,
    getSubscriptionsState: readonly(subscriptionsState),
    searchSubscriptions,
    loadMoreSubscriptions,
    getServicesState: readonly(servicesState),
    searchServices,
    loadMoreServices,
    getPerformancesState: readonly(performancesState),
    getShowsState: reactive(showState),
    searchPerformances,
    loadMorePerformances,
    searchShows,
    loadMoreShows,
    getSelectTypes: readonly(selectTypes),
    setSelectTypes,
  };
}
